import { Box, HoverCard, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface SymptomIndicatorBarProps {
  symptomValue: number;
  barColor: string;
}

export const SymptomIndicatorBar = ({ symptomValue, barColor }: SymptomIndicatorBarProps) => {
  const { t } = useTranslation();
  const BAR_WIDTH = 50;
  const BAR_HEIGHT = 15;

  const measurementsLabel = (value?: number) => {
    const measurement =
      value === 1 ? t('patients_measurement_label').toLowerCase() : t('label_patient_has_measurement').toLowerCase();
    return `${value} ${measurement}`;
  };

  return (
    <HoverCard shadow={'md'}>
      <HoverCard.Target>
        <Box w={(symptomValue || 0) * BAR_WIDTH} h={BAR_HEIGHT} bg={barColor} />
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text size={'sm'}>{measurementsLabel(symptomValue)}</Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
